import React, { useEffect, useState } from "react";

import "./WelcomePageComponent.scss";
import { PlusWithCircle } from "../../constants/icons";
import { IWelcomePageComponentProps } from "./WelcomePageComponentProps";
import { globalActions, groupActions } from "../../store/actions";
import { getTranslate } from "react-localize-redux";
import { useHistory, withRouter } from "react-router";
import { connect } from "react-redux";
import GroupCard from "../../components/group/groupListCard";
// import { push } from "connected-react-router";
import InfiniteScroll from "react-infinite-scroll-component";
import { GroupService } from "../../api/services/groups";
import CommunityCardLoader from "./CommunityCardLoader";

const WelcomePageComponent: React.FC<IWelcomePageComponentProps> = props => {

  const history: any = useHistory();

  const [groups, setGroupsData] = useState<{
    data: [];
    total: 0;
    next_page_url: "";
  }>({
    data: [],
    total: 0,
    next_page_url: ""
  });
  const [contentLoader, setContentLoader] = useState<boolean>(false);
  // load more groups with infinity scroll component
  function loadMoreGroups() {
    return GroupService.getInstance()
      .loadMoreUserGroups(`${groups.next_page_url}`)
      .then((response: any) => {
        // update group list
        const groupList: any = [...groups.data, ...response.data];
        // create copy of current group data
        const _groupData: any = { ...groups };
        // re-assign updated group datalist
        _groupData.data = groupList;
        _groupData.next_page_url = response.next_page_url;
        _groupData.per_page = response.per_page;
        _groupData.current_page = response.current_page;
        setGroupsData(_groupData);
      }).catch((error: any) => console.error(error))
  }
  useEffect(() => {
    setContentLoader(true);
    // @ts-ignore
    setGroupsData(props.userGroups);
    setTimeout(() => setContentLoader(false), 1000);
    }, []);


  return (
    <div className="content-page flex flex-justify-center">
      <div className="content-page-wrap">
        <div className={`card card-welcome ${contentLoader && 'card-welcome-loading'}`}>
          <h3>Welcome to GroupApp</h3>
          <span>Launch your community or create a new community</span>
          <button
            className={"btn btn-create-group"}
            onClick={() => {
              if(
                props.globalUser &&
                !props.globalUser.verified
              ) {
                history.push('/verify-account?r=true');
                return;
              }
              props.createGroup();
            }}
          >
            <PlusWithCircle />
            <span>Create community</span>
          </button>
        </div>
        <InfiniteScroll
          scrollableTarget={"scroll"}
          dataLength={groups.data.length}
          next={() => loadMoreGroups()}
          hasMore={groups.next_page_url ? true : false}
          loader={<>
            {
              Array.from({ length: 3 }).map((_, index) => {
                return <CommunityCardLoader key={index} />
              })
            }
          </>}
        >
          {contentLoader ?
            <>
              {
                Array.from({ length: 5 }).map((_, index) => {
                  return <CommunityCardLoader key={index} />
                })
              }
            </>
            : (
            groups.data.map((groupMembership: any) => {
              return (
                <GroupCard
                  key={groupMembership.id}
                  group={groupMembership.group}
                />
              );
            })
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

const mapDispatchToProps = (
  dispatch: any,
  ownProps: IWelcomePageComponentProps
) => {
  return {
    getGroups: () => {
      dispatch(globalActions.showTopLoading());
      dispatch(groupActions.dbGetAll());
    },
    createGroup: () => {
      const utm_content = process.env.REACT_APP_FREE_PLAN_UTM;
      window.location.assign(`/creategroup?utm_content=${utm_content}`)
      // dispatch(push(`/creategroup?utm_content=${utm_content}`));
    }
  };
};

const mapStateToProps = (state: any, ownProps: IWelcomePageComponentProps) => {
  const uid: string = state.getIn(["authorize", "uid"]) as string;
  const globalUser: any = state.getIn(["authorize", "user"]);
  return {
    translate: getTranslate(state.get("locale")),
    uid,
    globalUser,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WelcomePageComponent as any) as any
) as any;
